import { ref, watch, type Ref } from "vue";

export const useSelect = (itemIds: Ref<number[]>) => {
  const selectedIds = ref<number[]>([]);
  const selectMode = ref(false);

  const setSelectedIds = (ids: number[]) => {
    selectedIds.value = ids;
  };

  const toggleSelect = (drawingId: number) => {
    if (selectedIds.value.includes(drawingId)) {
      selectedIds.value = selectedIds.value.filter((id) => id !== drawingId);
    } else {
      selectedIds.value.push(drawingId);
    }
  };

  const toggleAll = (boolean: boolean | undefined | string | number) => {
    if (boolean) {
      selectedIds.value = itemIds.value;
    } else {
      selectedIds.value = [];
    }
  };
  watch(
    () => selectedIds.value.length,
    (newValue, prevValue) => {
      if (!newValue && !!prevValue) {
        selectMode.value = false;
      } else if (!!newValue && !prevValue) {
        selectMode.value = true;
      }
    }
  );

  return {
    selectedIds,
    selectMode,
    setSelectedIds,
    toggleSelect,
    toggleAll,
  };
};
